export const DEFAULT_GAME_TYPE = "outdoor";

export const SUPPORTED_GAME_TYPES = Object.freeze([
  "outdoor",
  "online",
  "escape_box",
]);

export function normalizeGameType(value) {
  const normalized = String(value || DEFAULT_GAME_TYPE).toLowerCase();
  return SUPPORTED_GAME_TYPES.includes(normalized)
    ? normalized
    : DEFAULT_GAME_TYPE;
}

function safeAssetUrl(value) {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  if (!trimmed) return undefined;
  if (/^(https?:\/\/|\/)/i.test(trimmed)) return trimmed;
  return undefined;
}

function safeColor(value) {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  if (/^#[0-9a-f]{3,8}$/i.test(trimmed)) return trimmed;
  if (/^(rgb|rgba|hsl|hsla)\([0-9.,%\s-]+\)$/i.test(trimmed)) return trimmed;
  return undefined;
}

export function normalizeGameUiConfig(value) {
  const source = value && typeof value === "object" && !Array.isArray(value)
    ? value
    : {};

  const textureOpacity = Number(source.textureOpacity);

  return {
    backgroundTextureUrl: safeAssetUrl(source.backgroundTextureUrl),
    screenTextureUrl: safeAssetUrl(source.screenTextureUrl),
    panelTextureUrl: safeAssetUrl(source.panelTextureUrl),
    logoUrl: safeAssetUrl(source.logoUrl),
    backgroundColor: safeColor(source.backgroundColor),
    surfaceColor: safeColor(source.surfaceColor),
    textColor: safeColor(source.textColor),
    accentColor: safeColor(source.accentColor),
    textureOpacity: Number.isFinite(textureOpacity)
      ? Math.min(1, Math.max(0, textureOpacity))
      : undefined,
  };
}

export function readGamePresentation(data) {
  return {
    gameType: normalizeGameType(data?.gameType),
    uiConfig: normalizeGameUiConfig(data?.uiConfig),
  };
}
